import { Box, Img } from '@chakra-ui/react';
import React, {
  createContext,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import Quest2 from 'assets/glb/Quest2.jpg';
import { ColorProvider } from 'components/ui/ColorContext';
import { preloadedImages, preloadedGLBFiles } from 'utils/hooks/function';
import { assetImageSrc } from 'utils/hooks/imageSrc';
import { useParams, useNavigate } from 'react-router-dom';
import { getGameCreatorDemoData, getAnimations } from 'utils/game/gameService';
import {
  getBackgrounds,
  getAssignedGame,
} from 'utils/gameApplication/gamePlayService';
import LoadImg from 'assets/gif/SpartanGif.gif';
import { API_SERVER } from 'config/constant';
import Medieval from 'assets/glb/MedievalArtisanNPC 2.glb';
// import FuturisticMaleUser from 'assets/glb/03 FuturisticMaleUser.glb';
import FuturisticMaleUser from 'assets/glb/03 FuturisticMaleUser-6.glb';
// import FuturisticFemaleUser from 'assets/glb/FuturisticFemaleUser 3.glb';
import FuturisticFemaleUser from 'assets/glb/02_FuturisticFemaleUser-2.glb';
import MaleMentor from 'assets/glb/MaleMentor.glb';
import FemaleMentor from 'assets/glb/FemaleMentor.glb';
import RealFemaleUser from 'assets/glb/RealFemaleUser.glb';
import RealMaleUser from 'assets/glb/RealMaleUser.glb';
import RealFactorySupervisor from 'assets/glb/RealFactorySupervisor.glb';
import RealFemaleManager from 'assets/glb/RealFemaleManager.glb';
import RealTeamMember from 'assets/glb/RealTeamMember.glb';
import MedievalFemaleUser from 'assets/glb/04 MedievalFemaleUser.glb';
import MedievalMaleUser from 'assets/glb/05 MedievalMaleUser.glb';
import MedievalCastleMember from 'assets/glb/06 MedievalCastleMember.glb';
import FuturisticTeamMember from 'assets/glb/07 FuturisticTeamMember.glb';
import FuturisticCarOwner from 'assets/glb/08 FuturisticCarOwner.glb';
import MedievalMerchant from 'assets/glb/09 MedievalMerchant.glb';
import FuturisticScientist from 'assets/glb/10 FuturisticScientist.glb';
import FutureThemeNova from 'assets/glb/FemaleNPCNova.glb'
import FutureThemeAxel from 'assets/glb/MaleNPCAxel.glb'
import FutureThemeRiven from 'assets/glb/MaleNPCRiven.glb'
import FutureThemeIris from 'assets/glb/FemaleNPCIris.glb'
import FutureThemeMale from 'assets/glb/MalePlayer2.glb'
import FutureThemeMale1 from 'assets/glb/MalePlayer3.glb'
import FutureThemeFemale from 'assets/glb/FemalePlayer2.glb'
import FutureThemeFemale1 from 'assets/glb/FemalePlayer3.glb'
import Robo from 'assets/glb/Robo.glb';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { motion } from 'framer-motion';
import NoAuth from './playcards/NoAuth';
import EntirePreview from './EntirePreview';
// import NPC from 'assets/glb/Character_sample.glb';
import CompressedRoom from 'assets/glb/Compressed_room.glb';
import medievalcastle from 'assets/glb/medievalcastle.glb';
import MedievalEmporium from 'assets/glb/MedievalEmporium.glb';
import furturisticCity from 'assets/glb/Futuristiccity.glb';
import FutureThemeLab from 'assets/glb/FutureThemeLab.jpg';
import FutureThemeWorkshop from 'assets/glb/FutureThemeWorkshop.jpg';
import FutureThemeLab1 from 'assets/glb/FutureThemeLab1.jpg';
import FutureThemeWorkShop1 from 'assets/glb/FutureThemeWorkShop1.jpg';
import futuristicLab from 'assets/glb/Futuristiclab.glb';
import image from 'assets/glb/image.jpeg';
import NewBackground_2 from 'assets/glb/NewBackground_2.jpg'
import futuristicOffice from 'assets/glb/Futuristicoffice.glb';
import Magicaloffice from 'assets/glb/Magicaloffice.glb';
import Magicalunderground from 'assets/glb/Magicalunderground.glb';
import Realisticoffice from 'assets/glb/Realisticoffice.glb';
import Realworkplace from 'assets/glb/Realworkplace.glb';
import Realfactory from 'assets/glb/Realfactory.glb';
import collector from 'assets/glb/FuturisticFemaleUser 3.glb';
import Magicalgarden from 'assets/glb/Magicalgarden.glb';
import MagicalFemaleUser from 'assets/glb/MagicalFemaleUser.glb';
import MagicalMaleUser from 'assets/glb/MagicalMaleUser.glb';
import MagicalFemalePotionSage from 'assets/glb/MagicalFemalePotionSage.glb';
import MagicalFemaleEnchantress from 'assets/glb/MagicalFemaleEnchantress.glb';
import MagicalMaleWizard from 'assets/glb/MagicalMaleWizard.glb';
import NPC from 'assets/glb/Character_sample.glb';
import MobileOrientationPrompt from './playcards/MobileOrientationPrompt';
import LoadingScreen from './FutureTheme/LoadingScreen';
import { getAssignedlearnerGames } from 'utils/activitycontrols/activities';
import { getDeviceInfo } from './common';
export const ScoreContext = createContext<any>(null);

export type ProfileType = {
  score: any[];
  // completionScore: any[];
  completedLevels: string[];
  compQuest: any[];
  currentQuest: any;
  replayScore: any[];
  playerGrandTotal: {
    questScores: Record<string, any>;
  };

  playerGender: any;
  PlayerName: any;
  completeBadgseShow: any[];
};

const initialProfileObject: ProfileType = {
  score: [],
  // completionScore:[],
  completedLevels: ['1'],
  compQuest: [],
  currentQuest: 1,
  replayScore: [],
  playerGrandTotal: { questScores: {} },
  playerGender: '',
  PlayerName: '',
  completeBadgseShow: []
};
export interface promptType {
  name: string;
  value: any;
  DelseQ: string | number;
  quest: number;
}
type gameCharactertype = {
  gasId: number;
  name: string;
  voices: {
    npc: string;
    male: string;
    female: string;
    narrator: string;
  };
};
const GamePreview = () => {
  const audioCache: any = {};
  const user: any = JSON.parse(localStorage.getItem('user'));
  const audioCacheRef = useRef<any>({});
  const [isAssignmentError, setIsAssignmentError] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [questBackgrounds, setQuestBackgrounds] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { learner_game_play_id } = useParams();
  const InitialScreenId = useRef(10);
  const [gameInfo, setGameInfo] = useState<any | null>(null);
  const [gameId, setGameId] = useState<any | null>(null);

  const [profile, setProfile] = useState(initialProfileObject);
  const [deviceInfo, setDeviceInfo] = useState<any>(null);
  const [learnerActivityrec, setlearnerActivityrec] = useState({
    learnerdetails: {
      playerId: user?.data?.id,
      playerType: user?.data?.role,
      GameId: learner_game_play_id,
      LearnerProfile: {
        name:  '',
        age:  '',
        companyId:  '',
        CountryId:  '',
        gender:  '',
        Department:  '',
        language: 1,
        education:  '',
        mailId:  '',
        nickName:  '',
        region:  '',
      }
    },
    screendetails:[],
  });
  const [contentReady, setContentReady] = useState<boolean>(null);
  const [apiImageSet, setApiImageSet] = useState<any>();
  const [staticAssetImageUrls, setStaticAssetImageUrls] = useState<any>(null);
  const [apiUrlAssetImageUrls, setApiUrlAssetImageUrls] = useState<any>(null); //preloaded Api image urls
  const [componentsLoaded, setComponentsLoaded] = useState(false);
  const [loadedGLBs, setLoadedGLBs] = useState<any>(null);

  const [animationOptions, setAnimationOptions] = useState<any>(null);
  const [glbName, setGlbName] = useState<any>(null);
  const [timer, setTimer] = useState<any>(false);
  const [seconds, setSeconds] = useState<number | null>(null);
  const [selectedBackground, setSelectedBackground] = useState<any>(null);
  // const [assignedData, setAssignedData] = useState<any>({});
  const [assignedData, setAssignedData] = useState<any>(null);

  const [isAuthFailed, setIsAuthFailed] = useState<{
    status: boolean;
    authMsg: string;
    reviewStatus: boolean;
  }>({ status: false, authMsg: '', reviewStatus: false });
  const navigate = useNavigate();
    const loadDeviceInfo = async () => {
    const info = await getDeviceInfo();
    setDeviceInfo(info);
  };

  const audioFiles = {

    IntroMusic: require("../../../assets/adiuo/intromusicone.mp3"),
  };
  const musicRef = React.useRef(null);
const openDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("AudioDB", 1);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains("audios")) {
        db.createObjectStore("audios");
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};
  useEffect(() => {
     loadDeviceInfo()
    if (isLoading) {
      // 🎵 Play Bill’s music when loader starts
      musicRef.current = new Audio(audioFiles.IntroMusic);
      musicRef.current.loop = true; // optional looping
      musicRef.current.volume = 0.8; // optional volume control (0–1)
      musicRef.current.play().catch((err: any) => {
        console.warn("Autoplay blocked by browser:", err);
      });
    } else {
      // ⏹️ Stop music when loader ends
      if (musicRef.current) {
        musicRef.current.pause();
        musicRef.current.currentTime = 0;
      }
    }

    // 🧹 Cleanup on unmount
    return () => {
      if (musicRef.current) {
        musicRef.current.pause();
        musicRef.current.currentTime = 0;
      }
    };
  }, [isLoading]);

  const parseGameNonPlayerOption = (value: any) => {
    if (Array.isArray(value)) return value;

    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error("Invalid JSON for gameNonPlayerOption", e);
        return [];
      }
    }

    return [];
  };

  const normalized = parseGameNonPlayerOption(
    gameInfo?.gameData?.gameNonPlayerOption
  );

  const [NonPlayerNameLanguageId, setNonPlayerNameLanguageId] = useState(normalized[0]?.gasId);
  const [filteredCharacterGLBs, setFilteredCharacterGLBs] = useState({});
  const [scenarioNpc, setScenarioNpc] = useState([]);

  const isInitialized = useRef(false);

  useEffect(() => {
    // if (!gameInfo) return;
    if (!gameInfo || isInitialized.current) return;
    isInitialized.current = true;

   
    const init = async () => {
      try {
        // 🚀 Run all async fetches in parallel
        const [resolvedResult, preloadedGLBs] = await Promise.all([
          preloadedImages(assetImageSrc), // preload images
          (async () => {
            // const gamebackground = String(gameInfo?.assets?.gasId);
            const gamebackground = gameInfo?.assets?.questBackgrounds?.map(
              (item: any) => String(item.backgroundId)
            ) || [];
            // const gamecharacter = String(
            //   gameInfo?.gameData?.gameNonPlayingCharacterId,
            // );

            const gamecharacter: gameCharactertype[] = normalized;
            const npcGasIds = gamecharacter.map(c => String(c.gasId));
            const allGLBs = [
              // Backgrounds
              {
                assetType: 'backgroundGlb',
                uniqueId: '1',
                src: CompressedRoom,
                // src: NewBackground_2,
                type: 'background',
              },
              {
                assetType: 'castleGlb',
                uniqueId: '2',
                src: medievalcastle,
                type: 'background',
              },
              {
                assetType: 'emporiumGlb',
                uniqueId: '3',
                src: MedievalEmporium,
                type: 'background',
              },
              {
                assetType: 'furturisticCity',
                uniqueId: '4',
                // src: furturisticCity,
                src: FutureThemeWorkshop,
                // src: Quest2,
                type: 'background',
              },
              {
                assetType: 'FutureThemeLab',
                uniqueId: '149',
                src: FutureThemeLab,
                type: 'background',
              },
              {
                assetType: 'FutureThemeWorkshop',
                uniqueId: '150',
                src: FutureThemeWorkshop,
                type: 'background',
              },
              {
                assetType: 'FutureThemeLab1',
                uniqueId: '151',
                src: FutureThemeLab1,
                type: 'background',
              },
              {
                assetType: 'FutureThemeWorkShop1',
                uniqueId: '152',
                src: FutureThemeWorkShop1,
                type: 'background',
              },
              {
                assetType: 'futuristicGlb',
                uniqueId: '5',
                // src: futuristicLab,
                src: FutureThemeLab,
                // src: NewBackground_2,
                type: 'background',
              },
              {
                assetType: 'futuristicOffice',
                uniqueId: '6',
                src: futuristicOffice,
                type: 'background',
              },
              {
                assetType: 'OfficeGlb',
                uniqueId: '7',
                src: Magicaloffice,
                type: 'background',
              },
              {
                assetType: 'UndergroundGlb',
                uniqueId: '8',
                src: Magicalunderground,
                type: 'background',
              },
              {
                assetType: 'Magicalgarden',
                uniqueId: '9',
                src: Magicalgarden,
                type: 'background',
              },
              {
                assetType: 'Realfactory',
                uniqueId: '10',
                src: Realfactory,
                type: 'background',
              },
              {
                assetType: 'Realworkplace',
                uniqueId: '11',
                src: Realworkplace,
                type: 'background',
              },
              {
                assetType: 'RealOfficeGlb',
                uniqueId: '12',
                src: Realisticoffice,
                type: 'background',
              },

              // Characters
              {
                assetType: 'Olivia',
                uniqueId: '32',
                src: RealFemaleManager,
                type: 'character',
              },
              {
                assetType: 'Riven',
                uniqueId: '33',
                src: RealTeamMember,
                type: 'character',
              },
              {
                assetType: 'Tristan',
                uniqueId: '23',
                src: MedievalCastleMember,
                type: 'character',
              },
              {
                assetType: 'Nova',
                uniqueId: '27',
                src: FuturisticTeamMember,
                type: 'character',
              },
              {
                assetType: 'Iris',
                uniqueId: '25',
                src: FuturisticCarOwner,
                type: 'character',
              },
              {
                assetType: 'Belthor',
                uniqueId: '24',
                src: MedievalMerchant,
                type: 'character',
              },
              {
                assetType: 'Zane',
                uniqueId: '26',
                src: FuturisticScientist,
                type: 'character',
              },
              {
                assetType: 'Evelina',
                uniqueId: '22',
                src: Medieval,
                type: 'character',
              },
              {
                assetType: 'Iris',
                uniqueId: '153',
                src: FutureThemeIris,
                type: 'character',
              },
              {
                assetType: 'Nova',
                uniqueId: '154',
                src: FutureThemeNova,
                type: 'character',
              },
              {
                assetType: 'Axel',
                uniqueId: '155',
                src: FutureThemeAxel,
                type: 'character',
              },
              {
                assetType: 'Riven',
                uniqueId: '156',
                src: FutureThemeRiven,
                type: 'character',
              },
              {
                assetType: 'Nerina',
                uniqueId: '30',
                src: MagicalFemalePotionSage,
                type: 'character',
              },
              {
                assetType: 'Eldrin',
                uniqueId: '29',
                src: MagicalMaleWizard,
                type: 'character',
              },
              {
                assetType: 'Thalassa',
                uniqueId: '28',
                src: MagicalFemaleEnchantress,
                type: 'character',
              },
              {
                assetType: 'Eldrin142',
                uniqueId: '142',
                src: RealFemaleManager,
                type: 'character',
              },
              {
                assetType: 'Thalassa143',
                uniqueId: '143',
                src: RealTeamMember,
                type: 'character',
              },

              // PCs
              {
                assetType: 'FuturisticMaleUser',
                uniqueId: '1',
                src: FuturisticMaleUser,
                theme: 'Future',
                type: 'pc',
              },
              {
                assetType: 'FuturisticFemaleUser',
                uniqueId: '2',
                src: FuturisticFemaleUser,
                theme: 'Future',
                type: 'pc',
              },
              {
                assetType: 'RealFemaleUser',
                uniqueId: '3',
                src: RealFemaleUser,
                theme: 'Real',
                type: 'pc',
              },
              {
                assetType: 'RealMaleUser',
                uniqueId: '4',
                src: RealMaleUser,
                theme: 'Real',
                type: 'pc',
              },
              {
                assetType: 'MedievalFemaleUser',
                uniqueId: '5',
                src: MedievalFemaleUser,
                theme: 'Medieval',
                type: 'pc',
              },
              {
                assetType: 'MedievalMaleUser',
                uniqueId: '6',
                src: MedievalMaleUser,
                theme: 'Medieval',
                type: 'pc',
              },
              {
                assetType: 'MagicalMaleUser',
                uniqueId: '7',
                src: MagicalMaleUser,
                theme: 'Magical',
                type: 'pc',
              },
              {
                assetType: 'MagicalFemaleUser',
                uniqueId: '8',
                src: MagicalFemaleUser,
                theme: 'Magical',
                type: 'pc',
              },
              {
                assetType: 'FutureThemeMale',
                uniqueId: '9',
                src: FutureThemeMale,
                theme: 'FutureTheme',
                type: 'pc',
              },
              {
                assetType: 'FutureThemeFemale',
                uniqueId: '10',
                src: FutureThemeFemale,
                theme: 'FutureTheme',
                type: 'pc',
              },
              {
                assetType: 'FutureThemeMale1',
                uniqueId: '11',
                src: FutureThemeMale1,
                theme: 'FutureTheme',
                type: 'pc',
              },

              {
                assetType: 'FutureThemeFemale1',
                uniqueId: '12',
                src: FutureThemeFemale1,
                theme: 'FutureTheme',
                type: 'pc',
              },
              {
                assetType: 'FuturisticMaleUser',
                uniqueId: '13',
                src: FuturisticMaleUser,
                theme: 'FutureTheme',
                type: 'pc',
              },
              {
                assetType: 'FuturisticFemaleUser',
                uniqueId: '14',
                src: FuturisticFemaleUser,
                theme: 'FutureTheme',
                type: 'pc',
              },
              {
                assetType: 'MaleMentor',
                uniqueId: '15',
                src: MaleMentor,
                theme: 'FutureThemeMentor',
                type: 'pc',
              },
              {
                assetType: 'FemaleMentor',
                uniqueId: '16',
                src: FemaleMentor,
                theme: 'FutureThemeMentor',
                type: 'pc',
              },
            ];


            const primaryBackground = gamebackground?.[0];
          

          

            const bg = String(primaryBackground);

            let theme: any = [];

            if (['1', '2', '3'].includes(bg)) {
              theme = ['Medieval'];
            }
            else if (['4', '5', '6'].includes(bg)) {
              theme = ['Future'];
            }
            else if (['7', '8', '9'].includes(bg)) {
              theme = ['Magical'];
            }
            else if (['10', '11', '12'].includes(bg)) {
              theme = ['Real'];
            }
            else if (['149', '150', '151', '152'].includes(bg)) {
              theme = ['FutureTheme', 'FutureThemeMentor'];
            }

          


            const filteredCharacterGLBs = allGLBs.filter(
              (glb) =>
                glb.type === 'character' &&
                npcGasIds.includes(String(glb.uniqueId))
            );



            // setFilteredCharacterGLBs(filteredCharacterGLBs)

            const specialCharacter = allGLBs.find(
              (glb) => glb.type === 'character'
              // (glb) => glb.type === 'character' && String(glb.uniqueId) === '26'
            );



            const includes_ZaneAlways = [
              ...filteredCharacterGLBs,
              ...(specialCharacter ? [specialCharacter] : []),
            ];


            setFilteredCharacterGLBs(includes_ZaneAlways);

            const filteredBackgroundGLBs = allGLBs.filter(
              (glb) =>
                glb.type === 'background' &&
                gamebackground.includes(String(glb.uniqueId))
            );



            // const matchingPCAssets = allGLBs.filter(
            //   (glb) => glb.type === 'pc' && glb.theme === theme,
            // );

            const matchingPCAssets = allGLBs.filter(
              (glb) => glb.type === 'pc' && theme.includes(glb.theme),
            );

            const themedGLBs = [
              ...filteredCharacterGLBs,
              ...filteredBackgroundGLBs,
              ...matchingPCAssets,
              ...includes_ZaneAlways,
            ].map((glb) => ({ ...glb, theme }));
          
            return preloadedGLBFiles(themedGLBs); // batch load 🚀
          })(),
        ]);

        // ✅ Set images + GLBs at the same time
        setStaticAssetImageUrls(resolvedResult);
        setLoadingProgress(45);
        setLoadedGLBs((prev: any) => ({ ...prev, preloadedGLBs }));
        setLoadingProgress(65);
        // Mark components ready
        setComponentsLoaded(true);

        // Screen setup
        // handleFullScreen();
      } catch (err) {
        console.error('Init failed:', err);
      }
    };
    init();
    setScenarioNpc(normalized);
    setNonPlayerNameLanguageId(normalized[0]?.gasId)
  }, [gameInfo]);

  useEffect(() => {
    learner_game_play_id && fetchCreatorDemoData();
  }, [learner_game_play_id]);

  const redirectHome = () => {
    navigate('/', { replace: true });
  };

 
 
  const fetchCreatorDemoData = async () => {
    setLoadingProgress(50);
    const ctId = user?.data?.id;
    if (!ctId) {
     redirectHome();
      //setIsAuthFailed({
       // status: true,
       // authMsg: 'Your session has timed out. Please login then try again.',
    //    reviewStatus: false,
    //  });
      return;
    }
  //  const assignedGames = await getAssignedGame(ctId);
   const assignedGames = await getAssignedGame(learner_game_play_id);
    // const assignedGames = await getAssignedlearnerGames(learner_game_play_id);
     if (
  assignedGames?.status === "Failure" &&
  assignedGames?.message?.toLowerCase().includes("unauthorized")
) {
   localStorage.removeItem("user");
    // redirectHome();
    navigate('/login')
    return;
  }
    const allowedGameIds = Array.isArray(assignedGames?.data)
      ? assignedGames.data.map((item: any) => String(item?.gameId))
      : [];
    //let gameId = learner_game_play_id;
  const gameId = String(learner_game_play_id);

    if (!allowedGameIds.includes(gameId)) {
      redirectHome();
      return;
    }
    const gamedata = await getGameCreatorDemoData(gameId, ctId);

 //   if (!gamedata?.error && gamedata) {
 const isOwnGame =
      !gamedata?.LearnerDetails?.ctId ||
      String(gamedata?.LearnerDetails?.ctId) === String(ctId);

    if (gamedata?.error || gamedata?.status === 'Failure' || !isOwnGame) {
      redirectHome();
      return;
    }

    if (gamedata) {
      updateCreatorGameInfo(gamedata);
   
      const backgroundIdselected = gamedata?.result?.gameBackgroundId;
      const quest1backgroundId = gamedata?.result?.gameQuest[0]?.gameBackgroundId;
      const quest2backgroundId = gamedata?.result?.gameQuest[1]?.gameBackgroundId;
      const quest3backgroundId =gamedata?.result?.gameQuest[2]?.gameBackgroundId;
      const quest4backgroundId =gamedata?.result?.gameQuest[3]?.gameBackgroundId;
      setGameId(gamedata?.result?.gameId)
      setQuestBackgrounds({
        1: quest1backgroundId,
        2: quest2backgroundId,
        3: quest3backgroundId,
      4: quest4backgroundId,
        // Add more if you have more quests
      });
      setSelectedBackground(backgroundIdselected);
      setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
    } else {
      redirectHome();
      return;
     // setIsAuthFailed({
    //    status: true,
     //   authMsg: 'Game is not availble at the moment..!',
     //   reviewStatus: false,
    //  });
    }
    const animationOptions = await getAnimations(gameId);
    if (!animationOptions?.error) {
      setAnimationOptions(animationOptions?.data);
      setGlbName(animationOptions?.assetImages?.gasglbname);
      setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
    } else {
      redirectHome();
      //setIsAuthFailed({
     //   status: true,
     //   authMsg: 'Game is not availble at the moment..!',
     //   reviewStatus: false,
     // });
    }
  };
    const blocksarrangebyRoll = (allBlocks: any) => {
    const SPECIAL_ROLES = ["Narrator", "999999", "99999"];
    const updatedBlocks: any = {};
    Object.keys(allBlocks || {}).forEach((questNo: any) => {
      const questBlocksObj = allBlocks[questNo];
      const questBlocksArray: any[] = Object.values(questBlocksObj);
      questBlocksArray.forEach((block: any) => {
        // Only Note & Dialog
        if (!["Note", "Dialog"].includes(block.blockChoosen)) return;
        // Only special roles
        if (!SPECIAL_ROLES.includes(block.blockRoll)) return;
        let targetBlock: any = null;
        let nextCharacter: any = "";
        // 🔹 Normal next block
        if (block.blockLeadTo) {
          targetBlock = questBlocksArray.find(
            (b: any) => b.blockSecondaryId == block.blockLeadTo
          );
        }
        if (!targetBlock) return;
        // 🟢 If next is Note or Dialog
        if (["Note", "Dialog"].includes(targetBlock.blockChoosen)) {

          nextCharacter = SPECIAL_ROLES.includes(targetBlock.blockRoll)
            ? "9999"
            : targetBlock.blockRoll;
        
        }

        // 🟢 If next is Interaction
        else if (targetBlock.blockChoosen === "Interaction") {

          if (SPECIAL_ROLES.includes(targetBlock.blockRoll)) {
            nextCharacter = SPECIAL_ROLES.includes(targetBlock.blockResponseRoll)
              ? "9999"
              : targetBlock.blockResponseRoll;
          } else {
            nextCharacter = targetBlock.blockRoll;
          }
        }

        block.blockTemporalRoll = nextCharacter;

      });

      // Convert back to object format
      updatedBlocks[questNo] = {};
      questBlocksArray.forEach((b: any, index: number) => {
        updatedBlocks[questNo][index + 1] = b;
      });

    });
    
    return updatedBlocks;
  };
const getAllAudioUrls = (demoblocks: any, questOptions: any) => {
    const urls = new Set();

    // Block audio
    Object.values(demoblocks).forEach((quest) => {
      Object.values(quest).forEach((block) => {
        if (block?.blockAudioUrl?.trim()) urls.add(block.blockAudioUrl);
        if (block?.blockAudioUrlFemale?.trim()) urls.add(block.blockAudioUrlFemale);
        // if (block?.blockAudioUrl) urls.add(block.blockAudioUrl);
        // if (block?.blockAudioUrlFemale) urls.add(block.blockAudioUrlFemale);
      });
    });

    // Option / Response / Feedback audio
    questOptions.forEach((option: any) => {
      if (option?.qbAudioUrl?.trim()) urls.add(option.qbAudioUrl);
      if (option?.qbAudioUrlFemale?.trim()) urls.add(option.qbAudioUrlFemale);
      if (option?.qbResponseAudioUrl?.trim()) urls.add(option.qbResponseAudioUrl);
      if (option?.qbfeedbackAudioUrl?.trim()) urls.add(option.qbfeedbackAudioUrl);
      // if (option?.qbAudioUrl) urls.add(option.qbAudioUrl);
      // if (option?.qbAudioUrlFemale) urls.add(option.qbAudioUrlFemale);

      // if (option?.qbResponseAudioUrl) urls.add(option.qbResponseAudioUrl);

      // if (option?.qbfeedbackAudioUrl) urls.add(option.qbfeedbackAudioUrl);
    });

    return Array.from(urls);
  };

  ///works without cache
  //  const preloadAudio = async (urls: string[]) => {
  //   const uniqueUrls = [...new Set(urls)];

  //   for (const url of uniqueUrls) {

  //     if (!url) continue;

  //     let fullUrl = url;

  //     if (!url.startsWith("http")) {
  //       const cleanUrl = url.startsWith("/") ? url : `/${url}`;
  //       fullUrl = `${API_SERVER}${cleanUrl}`;
  //     }

  //     await new Promise((resolve) => {

  //       const audio = new Audio();
  //       audio.src = fullUrl;
  //       audio.preload = "auto";

  //       audio.onloadeddata = () => {
  //         audioCacheRef.current[url] = audio;
  //         audioCache[url] = audio;
  //         resolve(true);
  //       };

  //       audio.onerror = () => {
  //         console.error("Audio preload failed:", fullUrl);
  //         resolve(false);
  //       };

  //     });

  //   }
  // };
 //aboveworks without cache



 //below works with cache
// const preloadAudio = async (urls: string[]) => {
//   const db = await openDB();

//   for (const url of urls) {
//     if (!url) continue;

//     try {
//       let fullUrl = url.startsWith("http")
//         ? url
//         : `${API_SERVER}/${url.replace(/^\/+/, "")}`;

//       // 🔹 Check cache first
//       const cached: Blob | null = await new Promise((resolve) => {
//         const tx = db.transaction("audios", "readonly");
//         const store = tx.objectStore("audios");
//         const req = store.get(url);

//         req.onsuccess = () => resolve(req.result || null);
//         req.onerror = () => resolve(null);
//       });

//       if (cached) {
//         const blobUrl = URL.createObjectURL(cached);
//         audioCacheRef.current[url] = new Audio(blobUrl);
//         continue;
//       }

//       // 🔹 Fetch audio
//       const response = await fetch(fullUrl);

//       // ❗ Handle bad response (404, 500, etc.)
//       if (!response.ok) {
//         console.warn("Audio failed (bad response):", fullUrl);
//         continue; // ✅ skip, don't break
//       }

//       const blob = await response.blob();

//       // 🔹 Save to IndexedDB
//       await new Promise<void>((resolve) => {
//         const tx = db.transaction("audios", "readwrite");
//         const store = tx.objectStore("audios");
//         store.put(blob, url);
//         tx.oncomplete = () => resolve();
//         tx.onerror = () => resolve(); // ✅ don't block
//       });

//       const blobUrl = URL.createObjectURL(blob);
//       audioCacheRef.current[url] = new Audio(blobUrl);

//     } catch (error) {
//       // ❗ VERY IMPORTANT
//       console.error("Audio preload failed:", url, error);

//       // ✅ Continue next audio (DO NOT STOP)
//       continue;
//     }
//   }
// };
//above works with cache



const CACHE_NAME = "audio-cache-v1";

// const preloadAudio = async (urls: string[]) => {
//   const cache = await caches.open(CACHE_NAME);

//   for (const url of urls) {
//     if (!url) continue;

//     let fullUrl = url.startsWith("http")
//       ? url
//       : `${API_SERVER}/${url.replace(/^\/+/, "")}`;

//     try {
//       // 🔹 Check cache first
//       const cachedResponse = await cache.match(fullUrl);

//       if (cachedResponse) {
//         const blob = await cachedResponse.blob();
//         const blobUrl = URL.createObjectURL(blob);
//         audioCacheRef.current[url] = new Audio(blobUrl);
//         continue;
//       }

//       // 🔹 Fetch from network
//       const response = await fetch(fullUrl);
//       if (!response.ok) continue;

//       // 🔹 Save to cache
//       await cache.put(fullUrl, response.clone());

//       const blob = await response.blob();
//       const blobUrl = URL.createObjectURL(blob);

//       audioCacheRef.current[url] = new Audio(blobUrl);

//     } catch (err) {
//       console.error("Cache audio failed:", fullUrl, err);
//     }
//   }
// };
const preloadAudio = async (urls:string[]) => {
  const cache = await caches.open("audio-cache-v1");

  const promises = urls.map(async (url) => {
    if (!url) return;

    let fullUrl = url.startsWith("http")
      ? url
      : `${API_SERVER}/${url.replace(/^\/+/, "")}`;

    try {
      // ✅ normalize URL (same as SW)
      const cleanUrl = new URL(fullUrl).origin + new URL(fullUrl).pathname;

      // ✅ check cache
      let response = await cache.match(cleanUrl);

      if (!response) {
        response = await fetch(fullUrl);
        if (response.ok) {
          await cache.put(cleanUrl, response.clone());
        }
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      audioCacheRef.current[url] = new Audio(blobUrl);

    } catch (err) {
      console.error("Audio preload failed:", fullUrl);
    }
  });

  await Promise.all(promises);
};

  const updateCreatorGameInfo = async (info: any) => {

    const {
      gameview,
      image,
      lmsblocks,
      lmsquestionsoptions,
      gameQuest,
      ...gameData
    } = info?.result;
   
    setProfile((prev: any) => ({
      ...prev,
      PlayerName: info?.LearnerDetails?.ctName,
      playerGender: info?.LearnerDetails?.ctGender,
    }));
    const sortBlockSequence = (blockArray: []) => {
      const transformedArray = blockArray.reduce((result: any, obj: any) => {
        const groupKey = obj?.blockQuestNo.toString();
        const seqKey = obj?.blockPrimarySequence.toString()?.split('.')[1];
        if (!result[groupKey]) {
          result[groupKey] = {};
        }
        result[groupKey][seqKey] = obj;
        return result;
      }, {});
      return transformedArray;
    };
    const getUpdatecharacterblocks = blocksarrangebyRoll(sortBlockSequence(lmsblocks));
   
    // const urls:any = getAllAudioUrls(getUpdatecharacterblocks, lmsquestionsoptions);
   
    // preloadAudio(urls).then(() => {
    //   setAudioReady(true);
    //   setLoadingProgress(85);
    // });
// const urls = getAllAudioUrls(getUpdatecharacterblocks, lmsquestionsoptions);

// 🎯 Load only first few (important)
// const initialUrls:any = urls.slice(0, 10);

// // 🚀 Load remaining later
// const remainingUrls:any = urls.slice(10);

// Load critical audio first
// await preloadAudio(initialUrls);
const urls:any = getAllAudioUrls(getUpdatecharacterblocks, lmsquestionsoptions);

await preloadAudio(urls);   // ✅ wait ALL

setAudioReady(true);        // ✅ only after complete
setLoadingProgress(90);


// Load rest in background (non-blocking)
// preloadAudio(remainingUrls);
    setlearnerActivityrec((prev: any) => ({
      ...prev,
      learnerdetails: {
        ...prev.learnerdetails,
        LearnerProfile: {
          name: info?.LearnerDetails?.lenUserName ?? "",
          age: info?.LearnerDetails?.lenAge ?? "",
          companyId: info?.LearnerDetails?.lenCompanyId ?? "",
          CountryId: info?.LearnerDetails?.lenCountryId ?? "",
          gender: info?.LearnerDetails?.lenGender ?? "",
          Department: info?.LearnerDetails?.lenDepartment ?? "",
          language: 1,
          education: info?.LearnerDetails?.lenEducation ?? "",
          mailId: info?.LearnerDetails?.lenMail ?? "",
          nickName: info?.LearnerDetails?.lenNickName ?? "",
          region: info?.LearnerDetails?.lenRegion ?? "",
        },
      },
    }));
    setGameInfo({
      learnerDetails: info?.LearnerDetails,
      gameId: info?.result?.gameId,
      gameData: gameData,
      gameHistory: gameview,
      assets: image,
      ChooseMiniGame: info?.miniGameData,
      blocks: getUpdatecharacterblocks,
      gameQuest: gameQuest, //used for completion screen
      completionQuestOptions: gameQuest,
      questOptions: lmsquestionsoptions,
      interactionfeedback: lmsquestionsoptions?.[0]?.interactionfeedback,
      reflectionQuestions: info?.resultReflection,
      gamePlayers: info?.assets?.playerCharectorsUrl,
      bgMusic:
        gameData?.gameIntroMusicName && gameData?.gameIntroMusic
          ? gameData?.gameIntroMusicName
          : '',
      gameNonPlayerUrl:
        info?.assets?.npcUrl && API_SERVER + '/' + info?.assets?.npcUrl,
    });
    const apiImageSetArr: any = [
      { assetType: 'backgroundImage', src: image?.gasAssetImage },
      {
        assetType: 'nonplayerImage',
        src: API_SERVER + '/' + info?.assets?.npcUrl,
      },
    ];
    let playerCharectorsUrls = info?.assets?.playerCharectorsUrl.map(
      (item: any, index: number) => {
        let objValue = API_SERVER + '/' + item;
        let objKey = `playerCharacterImage_${index}`;
        apiImageSetArr.push({ assetType: objKey, src: objValue });
      },
    );
    let gameQuestBadges = await Promise.all(
      info?.assets?.badges.map(async (item: Record<string, string>) => {
        Object.entries(item).forEach(([key, value]) => {
          let objkeyValue = key?.split('_')[1];
          let objKey = `Quest_${objkeyValue}`;
          let objKeyValue = API_SERVER + '/' + value;
          let badgeUrl = value?.split('.');
          const shadowBadgeUrl = badgeUrl?.[0] + '-shadow.' + badgeUrl?.[1];
          apiImageSetArr.push({ assetType: objKey, src: objKeyValue });
          apiImageSetArr.push({
            assetType: objKey + '-shadow',
            src: API_SERVER + '/' + shadowBadgeUrl,
          });
        });
        setApiImageSet(apiImageSetArr);
        return true;
      }),
    );
    // setLoadingProgress(25);
    setLoadingProgress(80);

  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resolvedResult: any = await preloadedImages(apiImageSet);
        setApiUrlAssetImageUrls(resolvedResult);
        setLoadingProgress(80);
      } catch (error) {
        console.error('Error preloading images:', error);
      }
    };
    apiImageSet && fetchData();
  }, [apiImageSet]);
  const preloadedAssets = useMemo(() => {
    return { ...apiUrlAssetImageUrls, ...staticAssetImageUrls, ...loadedGLBs };
  }, [apiUrlAssetImageUrls, staticAssetImageUrls, loadedGLBs]);

  useEffect(() => {
    if (
      gameInfo &&
      apiUrlAssetImageUrls &&
      Object.keys(apiUrlAssetImageUrls).length > 0 &&
      staticAssetImageUrls &&
      Object.keys(staticAssetImageUrls).length > 0 &&
      loadedGLBs &&
      Object.keys(loadedGLBs).length > 0 &&
      componentsLoaded === true && audioReady
    ) {
      setLoadingProgress(100);
      setContentReady(true);
      setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
    } else {
      setContentReady(false);
    }
  }, [
    gameInfo,
    apiUrlAssetImageUrls,
    staticAssetImageUrls,
    loadedGLBs,
    componentsLoaded,
    audioReady
  ]);
  useEffect(() => {
    const fetchData = async () => {
      const result = await getAssignedGame(learner_game_play_id);
       if (
  // result?.status === "Failure" &&
  result?.message?.toLowerCase().includes("Invalid token")
) {
   localStorage.removeItem("user");
    // redirectHome();
    navigate('/login')
    return;
  }
      if (result?.status === 'Success') {
        // setAssignId(result?.LearnerPlayinggame?.gaId);
        const learnerPlayingDetails = result?.LearnerPlayinggame
          ?.learnerGameplayDetails
          ? JSON.parse(result?.LearnerPlayinggame?.learnerGameplayDetails)
          : null;

        if (!result?.LearnerPlayinggame?.learnerGameplayDetails) {
          setSeconds(0);
           setAssignedData({});
        } else {
          const data = JSON.parse(
            result?.LearnerPlayinggame?.learnerGameplayDetails,
          );
          const recdata = JSON.parse(
            result?.LearnerPlayinggame?.learnerActivityDetails,
          );
          if (result?.LearnerPlayinggame?.learnerActivityDetails) {
            setlearnerActivityrec(recdata);
          }
          // const totalTimeSpent = data?.totalTimeSpent;

          // setAssignedData(data);
          const gameProgressData = JSON.parse(result?.LearnerPlayinggame?.gameProgressData);
          const totalTimeSpent = data?.totalTimeSpent;
          setProfile(learnerPlayingDetails?.PlayerScore_Level);
          setAssignedData({...data,gameProgressData:gameProgressData});
          const convertToSeconds = (time: any) => {
            const [minutes, seconds] = time.split(':').map(Number);
            return minutes * 60 + seconds;
          };

          // Access totalTimeSpent and convert it to seconds

          const totalTimeInSeconds = convertToSeconds(totalTimeSpent);

          setSeconds(totalTimeInSeconds);
        }
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (isAuthFailed.status === true || contentReady === true) {
      setIsLoading(false);
      setTimer(true);
    }
  }, [isAuthFailed, contentReady, isLoading]);

  return (
    <>

      {isLoading && (
        gameInfo?.gameData?.gameTheme === "false" ? (

          <InitialLoader />
        ) : (
          //  <LoadingScreen progress={loadingProgress} /> 
          <ColorProvider gamethemecolor={gameInfo?.gameData?.gameThemeColor || "#00FFBB"}>
            <LoadingScreen progress={loadingProgress} />
          </ColorProvider>
        )
      )}
      <Box background={'black'} h={'100vh'} width={'100vw'}>
        <MobileOrientationPrompt onRotate={() => { }} />



        {isAuthFailed.status === true && (
          <NoAuth
            isAuthFailed={isAuthFailed.status}
            status={isAuthFailed.authMsg}
            bgImage={preloadedAssets.introBgImage}
            isLoading={isLoading}
            reviewStatus={isAuthFailed.reviewStatus}
          />
        )}
        {contentReady === true && gameInfo?.gameId && audioReady && assignedData && (
          <ScoreContext.Provider value={{ profile, setProfile,learnerActivityrec,setlearnerActivityrec ,deviceInfo,setDeviceInfo ,isAssignmentError, setIsAssignmentError ,loadingProgress, setLoadingProgress}}>
            <Box id="container">
              <Box>
                <Box id="EntirePreview-wrapper">
                  <Box className="EntirePreview-content">
                    <Box id="container" className="Play-station">
                      <ColorProvider gamethemecolor={gameInfo?.gameData?.gameThemeColor || "#00FFBB"}>
                        <EntirePreview
                          gameInfo={gameInfo}
                          gameIdingamepreview={gameId}
                          setGameInfo={setGameInfo}
                          preloadedAssets={preloadedAssets}
                          InitialScreenId={InitialScreenId.current}
                          setIsAuthFailed={setIsAuthFailed}
                          isAuthFailed={isAuthFailed}
                          isLoading={isLoading}
                          glbName={glbName}
                          timer={timer}
                          setTimer={setTimer}
                          seconds={seconds}
                          setSeconds={setSeconds}
                          selectedBackground={selectedBackground}
                          assignedData={assignedData}
                          NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                          setNonPlayerNameLanguageId={setNonPlayerNameLanguageId}
                          filteredCharacterGLBs={filteredCharacterGLBs}
                          scenarioNpc={scenarioNpc}
                          gamethemecolor={gameInfo?.gameData?.gameThemeColor || "#00FFBB"}
                          audioReady={audioReady}
                          setAudioReady={setAudioReady}
                          audioCacheRef={audioCacheRef}
                          audioCache={audioCache}
                        />
                      </ColorProvider>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </ScoreContext.Provider>
        )}
      </Box>
    </>
  );
};
export default GamePreview;

function InitialLoader() {
  return (
    <>
      <Box className="Entire-Loader" style={{ zIndex: '99999 !important' }}>
        <motion.div
          className="Entire-Loader-wrapper"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{ zIndex: '99999 !important', opacity: 1 }}
        >
          <Img src={LoadImg} className="load"
            style={{ zIndex: '99999999 !important', opacity: 1 }} />
        </motion.div>
      </Box>
    </>
  );
}
